import { render, staticRenderFns } from "./custom-type5.vue?vue&type=template&id=a1b36182&scoped=true"
import script from "./custom-type5.vue?vue&type=script&lang=js"
export * from "./custom-type5.vue?vue&type=script&lang=js"
import style0 from "./custom-type5.vue?vue&type=style&index=0&id=a1b36182&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b36182",
  null
  
)

export default component.exports